import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useService } from "@/base/hooks/useService";
import { StorageService } from "@services/StorageService";
import { localstorageKeys } from "@const/store";
import { hashReceivedForms } from "@const/consentForms";
import { toggleSignInModal } from "@redux/signIn/actions";

const useHandleConsentFormLink = () => {
  const dispatch = useDispatch();
  const storageService = useService(StorageService);
  const { accessToken } = storageService.get(localstorageKeys.session, {});

  const pathname = window.location.pathname;

  useEffect(() => {
    const parts = pathname.split("/");
    const identifier = parts[parts.length - 1];

    if (
      pathname.includes("consent-forms") &&
      parts.length === 4 &&
      !accessToken
    ) {
      storageService.set(
        localstorageKeys.destination,
        `/consent-forms/${identifier}${hashReceivedForms}`,
      );
      dispatch(toggleSignInModal(true));
    }
  }, [window.location.href]);
};

export default useHandleConsentFormLink;
